import React from 'react';
import { Grid } from '@mui/material';
import { RootineFooter, BloodUploadForm } from '../components';

export const BloodUpload = (): JSX.Element => {
  return (
    <>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        sx={{
          px: { xs: 2, sm: 10, lg: 35 },
          marginTop: { xs: 10, md: 20 },
        }}
      >
        <Grid item xs={12}>
          <BloodUploadForm />
        </Grid>
        <Grid item xs={12}>
          <RootineFooter />
        </Grid>
      </Grid>
    </>
  );
};
